import { FC, PropsWithChildren } from 'react';

import { GlobalStyles } from '@mui/material';
import { SnackbarProvider } from 'notistack';

import { CustomAlert } from '@/shared/ui/components/alerts/CustomAlert';

import { SNACKBAR_TOP_OFFSET_MOBILE } from '@/shared/ui/constants';

import { ThemeProvider } from '@/app/theme/ThemeProvider';

/** Класс контейнера снекбаров: notistack не принимает sx, стили — через GlobalStyles */
const SNACKBAR_CONTAINER_CLASS = 'app-snackbar-container';

/**
 * Провайдер для темы
 * @param root0 Пропсы
 * @param root0.children Дочерние элементы
 */
export const Theme: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ThemeProvider>
      <GlobalStyles
        styles={theme => ({
          // Два класса: notistack ставит свой `top: 14px` одноклассовым goober-правилом,
          // порядок вставки стилей не гарантирован — берём специфичностью
          [`.notistack-SnackbarContainer.${SNACKBAR_CONTAINER_CLASS}`]: {
            // Только ниже lg: там сверху фиксированный MobileTopBar, который нельзя
            // отскроллить. На десктопе — штатная позиция notistack, без сдвига
            [theme.breakpoints.down('lg')]: {
              top: SNACKBAR_TOP_OFFSET_MOBILE
            }
          }
        })}
      />
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        classes={{ containerAnchorOriginTopRight: SNACKBAR_CONTAINER_CLASS }}
        Components={{ customAlert: CustomAlert }}
      >
        {children}
      </SnackbarProvider>
    </ThemeProvider>
  );
};
